// Flag image paths for each market, keyed by market database id.
// Markets themselves come from the DB (/get-markets); this only maps id -> flag asset.
export const FLAG_MAP = {
  1: '/flags/usa.png',
  2: '/flags/canada.png',
  3: '/flags/germany.png',
  4: '/flags/uk.png',
  5: '/flags/australia.png',
  6: '/flags/playground.png',
  12: '/flags/usa.png',
  13: '/flags/france.png',
};

// Fallback used when a market id has no specific flag asset.
export const PLACEHOLDER_FLAG = '/flags/placeholder.png';
